module.exports = __webpack_public_path__ + "img/ST.232b0c8a.png";